import { Action, createReducer, on } from '@ngrx/store';
import {
    getDWSMCounterFail,
    getDWSMCounterSuccess,
    getWorkstockCounterFail,
    getWorkstockCounterSuccess,
    getWorkstockSubCountersNavSuccess
} from './navigation.actions';
import { NavigationState, initialState } from './navigation.state';
import { getWorkstockSubCountersSuccess, loadWorkstockComponent } from '../../workstock/state/workstock.actions';
import { getDwsmDashboard } from 'src/app/dwsm/state/dwsm.actions';

const reducer = createReducer(
    initialState,
    on(
        loadWorkstockComponent,
        (state): NavigationState => ({
            ...state,
            loadingWorkstockCounter: true
        })
    ),
    on(
        getWorkstockCounterSuccess,
        (state, action): NavigationState => ({
            ...state,
            workstockCounter: action.workstockCounter,
            loadingWorkstockCounter: false
        })
    ),
    on(
        getWorkstockSubCountersNavSuccess,
        (state, action): NavigationState => ({
            ...state,
            favoriteCounter: action.favoriteCounter
        })
    ),
    on(
        getWorkstockSubCountersSuccess,
        (state, action): NavigationState => ({
            ...state,
            favoriteCounter: action.workstockSubCounters.favoriteCounter
        })
    ),

    on(
        getWorkstockCounterFail,
        (state): NavigationState => ({
            ...state,
            loadingWorkstockCounter: false
        })
    ),
    on(
        getDwsmDashboard,
        (state): NavigationState => ({
            ...state,
            loadingDWSMCounter: true
        })
    ),
    on(
        getDWSMCounterSuccess,
        (state, action): NavigationState => ({
            ...state,
            dwsmCounter: action.dwsmCounter,
            loadingDWSMCounter: false
        })
    ),
    on(
        getDWSMCounterFail,
        (state): NavigationState => ({
            ...state,
            loadingDWSMCounter: false
        })
    )
);

export function navigationReducer(state: NavigationState, action: Action): NavigationState {
    return reducer(state, action);
}
